import React, {useCallback} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {useTheme} from 'themes'
import {useDidUpdate} from 'utils'
import {Icon, Input, Paragraph} from 'common/components'
import {useDispatch} from 'lib/redux'
import convertUnit from 'lib/unit'
import {GiftShopTemplateUploadFormLocationProps} from './GiftShopTemplateUploadFormLocationProps'

const StyledError = styled(Paragraph)`
  ${({theme}) => ({color: theme.danger_5})}
  box-sizing: border-box;
  margin-top: ${convertUnit(7)};
  margin-bottom: ${convertUnit(2)};
`

export default function GiftShopTemplateUploadFormLocation({
  form,
  location,
  onAddLocation,
  toggleModal,
  handleValidateTagsAndLocation,
  handleClearTagsAndLocation,
}: GiftShopTemplateUploadFormLocationProps) {
  const {translate} = useTranslation()
  const theme = useTheme()
  const {errors, setValue, watch} = form
  const {update} = useDispatch()
  const {tags} = watch()
  const disabled = tags.length > 0

  const handleClickLocation = useCallback(() => {
    toggleModal()
    onAddLocation && onAddLocation(form)
    if (location) {
      update('lastUploadStatePhoto', {
        name: JSON.parse(location).name,
        latitude: JSON.parse(location).latitude,
        longitude: JSON.parse(location).longitude,
      })
      update('lastUploadStateVideo', {
        name: JSON.parse(location).name,
        latitude: JSON.parse(location).latitude,
        longitude: JSON.parse(location).longitude,
      })
    }
    setValue('location', location)
  }, [form, location, onAddLocation, setValue, toggleModal, update])

  useDidUpdate(() => {
    setTimeout(() => {
      handleValidateTagsAndLocation({})
    }, 10)
  }, [handleValidateTagsAndLocation, tags])

  return (
    <>
      <Input
        value={tags.length > 0 ? '' : location && JSON.parse(location).name}
        form={form}
        leftIcon={
          <Icon
            type="location"
            color={disabled || location === '' ? 'gray_3' : 'black_1'}
          />
        }
        autoComplete={false}
        placeholder={translate('giftShop:uploadInputLocationPlaceholder')}
        inputContainerStyle={
          errors.location ? {borderColor: theme.danger_5} : undefined
        }
        rightIcon="delete"
        onClick={handleClickLocation}
        onRightIconClick={handleClearTagsAndLocation}
        disabled={disabled}
        onBlur={() => handleValidateTagsAndLocation({})}
      />
      {errors.location && (
        <StyledError fontWeight="medium">{errors.location.message}</StyledError>
      )}
    </>
  )
}
